import classNames from 'classnames';
import { Field, useFormikContext } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { connect } from 'react-redux';
import { BlankTarget } from '../../components/BlankTarget';
import { PTErrors, PTInfo, PTInputSelect, PTInputText, PTInputCheckbox } from '../../components/PTElements';
import { appointmentCountEquality, appointmentStatus, cancellationReasons, recallFilter, scheduleTypes, when_Automated } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/notificationchores";
import './NCDFilter.css';
import { Question } from './Question';

const NCDF = (props) => {
    const { values, setFieldValue } = useFormikContext();
    const [appointmentTypes, setAppointmentTypes] = useState([]);
    const [invalidAppointmentTypes, setInvalidAppointmentTypes] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(groups.Essentials);

    useEffect(() => {
        const appCats = values.appointmentCategories || [];
        let applicable = props.appointmentTypes;
        if (EVO.any(appCats)) {
            applicable = props.appointmentTypes.filter(at => appCats.includes(at.category));
        }

        const notApplicable = applicable.filter(a => a.name.startsWith('~*'));
        setInvalidAppointmentTypes(notApplicable);
        applicable = applicable.filter(a => !a.name.startsWith('~*'));


        const bob = EVO.getSelectItemFromObject(applicable, p => p.name, p => p.id);
        setAppointmentTypes(bob);

        const appTypes = values.appointmentTypes;
        if (EVO.any(appTypes)) {
            const newAppTypes = appTypes.filter(at => EVO.any(applicable, a => a.id === at));
            setFieldValue('appointmentTypes', newAppTypes);
        }

    }, [values.appointmentCategories]);

    const DateRangePicker = () => {
        const { values, setFieldValue } = useFormikContext();
        const [dateRange, setDateRange] = useState([{
            startDate: new Date(values.oneOffFrom),
            endDate: new Date(values.oneOffTo),
            key: 'selection'
        }]);

        const setDates = item => {
            setFieldValue('oneOffFrom', EVO.format(item.selection.startDate, "yyyy-MM-dd'T'HH:mm"));
            setFieldValue('oneOffTo', EVO.format(item.selection.endDate, "yyyy-MM-dd'T'HH:mm"));
            setDateRange([item.selection]);
        };

        if (values.scheduleTypeId === scheduleTypes.OneOff.value) {
            return <PersonOption header="Appointment Date Range" required subHeader="Patients who have a past or upcoming appointment within the date range specified here will receive your SMS">
                <DateRange
                    onChange={setDates}
                    ranges={dateRange}
                    color="#0f1042"
                />
            </PersonOption>;
        }

        return <div></div>;
    };

    const RenderGroup = ({ g }) => {
        if (g.id === groups.Essentials.id) {
            return <div>
                {useMemo(() => <DateRangePicker />, [values.scheduleTypeId])}
                {values.scheduleTypeId === scheduleTypes.OneOff.value && <PersonOption header="Recall" set={true}>
                    <Field name="requiresUpcomingAppointmentsCheck" component={PTInputCheckbox} placeholder="Is this a recall?" />
                    {values.requiresUpcomingAppointmentsCheck && <div>
                        <div className="ncd-fitler-only-send">Only send if the patient has not booked an appointment..</div>
                        <Field name="recallFilter" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(recallFilter)}
                            placeholder="" center="true" />
                    </div>}
                </PersonOption>}
                {values.whenAutomatedId === when_Automated.AfterMedicalAlertAdded.value && <PersonOption
                    header="Medical Alert"
                    subHeader={<span>Please select which medical alert/s will trigger this message. The alert must already exist. <BlankTarget text="Here's how" href="http://help.peptalkr.com.au/en/articles/5390584-triggering-a-message-when-a-medical-alert-is-added-to-a-patient" /> to do it.</span>}
                    set={EVO.any(values.medicalAlerts)}
                    excludeName="medicalAlertsExclude" required>
                    {props.medicalAlerts && <Field name="medicalAlerts" component={PTInputSelect} options={EVO.getSelectItemFromSingularArray(props.medicalAlerts)} isMulti={true} />}
                </PersonOption>}
                {values.whenAutomatedId === when_Automated.OnCount.value && <NumberOfAppointments hideOptions={true} />}
                {values.whenAutomatedId === when_Automated.OnCount.value && <PersonOption header="Appointment Status" set={true} subHeader="Arrived also includes anyone who was not marked anything (they were not marked Did Not Arrive or Cancelled)">
                    {<Field name="appointmentStatus" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(appointmentStatus)} />}
                </PersonOption>}
                <PersonOption header="Business" set={EVO.any(values.businesses)} excludeName="businessExclude" values={values} setFieldValue={setFieldValue}>
                    {props.businesses && <Field name="businesses" component={PTInputSelect} options={EVO.getSelectItemFromObject(props.businesses, p => p.displayName || p.name, p => p.id)}
                        isMulti={true} />}
                </PersonOption>
                {(values.whenAutomatedId === when_Automated.AfterInvoiceCreated.value || values.whenAutomatedId === when_Automated.AfterInvoiceClosed.value) && <div>
                    <PersonOption header="Products" set={EVO.any(values.products)} excludeName="productsExclude">
                        {props.products && <Field name="products" component={PTInputSelect} options={EVO.getSelectItemFromObject(props.products, p => p.name, p => p.id)}
                            isMulti={true} />}
                    </PersonOption>
                </div>}
                {(values.whenAutomatedId === when_Automated.AfterInvoiceCreated.value || values.whenAutomatedId === when_Automated.AfterInvoiceClosed.value) && <div>
                    <PersonOption header="Billable Items" set={EVO.any(values.billableItems)} excludeName="billableItemsExclude">
                        {props.billableItems && <Field name="billableItems" component={PTInputSelect} options={EVO.getSelectItemFromObject(props.billableItems, p => p.name, p => p.id)}
                            isMulti={true} />}
                    </PersonOption>
                </div>}
                {values.whenAutomatedId === when_Automated.AfterCancelled.value && <div>
                    <PersonOption header="Cancellation Reason" set={EVO.any(values.cancellationReasons)} excludeName="cancellationReasonsExclude">
                        {<Field name="cancellationReasons" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(cancellationReasons)} isMulti={true} />}
                    </PersonOption>
                </div>}
            </div>;
        }
        else if (g.id === groups.Demographics.id) {
            return <div>
                <PersonOption header="Sex" set={EVO.any(values.sexes)} excludeName="sexesExclude">
                    {props.sexes && <Field name="sexes" component={PTInputSelect} options={EVO.getSelectItemFromSingularArray(props.sexes)} isMulti={true} />}
                </PersonOption>
            </div>;
        }
        else if (g.id === groups.Appointment.id) {
            if (values.whenAutomatedId === when_Automated.AfterInvoiceCreated.value || values.whenAutomatedId === when_Automated.AfterMedicalAlertAdded.value || values.whenAutomatedId === when_Automated.AfterInvoiceClosed.value) {
                return null;
            }
            return <div>
                <PersonOption header="Appointment Category" set={EVO.any(values.appointmentCategories)} excludeName="appointmentCategoryExclude">
                    {props.appointmentCategories && <Field name="appointmentCategories"
                        component={PTInputSelect}
                        options={EVO.getSelectItemFromObject(props.appointmentCategories, p => p, p => p)}
                        isMulti={true} />}
                </PersonOption>
                <PersonOption header="Appointment Type" set={EVO.any(values.appointmentTypes)} excludeName="appointmentTypeExclude">
                    {appointmentTypes && <Field name="appointmentTypes"
                        component={PTInputSelect}
                        options={appointmentTypes}
                        isMulti={true} />}
                    {invalidAppointmentTypes && invalidAppointmentTypes.length > 0 && <div className="ncd-invalid-apptypes">
                        <div>*These appointment types are automatically <a href="https://help.peptalkr.com.au/en/articles/9187889-stop-specific-appointment-types-from-sending-email-and-sms" target="_blank" rel="noopener noreferrer">excluded</a>:</div>
                        <ul>
                            {invalidAppointmentTypes.map(a => <li key={a.name}>{a.name}</li>)}
                        </ul>
                    </div>}
                </PersonOption>
                <PersonOption header="Practitioner" set={EVO.any(values.practitioners)} excludeName="practitionerExclude">
                    {props.practitioners && <Field name="practitioners" component={PTInputSelect} options={EVO.getSelectItemFromObject(props.practitioners, p => p.label, p => p.id, p => p.sortLabel)}
                        isMulti={true} />}
                </PersonOption>
                {(values.whenAutomatedId !== when_Automated.OnCount.value && values.whenAutomatedId !== when_Automated.AfterInvoiceCreated.value && values.whenAutomatedId !== when_Automated.AfterInvoiceClosed.value) && <NumberOfAppointments />}
            </div>;
        }
        else if (g.id === groups.Other.id) {
            return <div>
                {values.whenAutomatedId !== when_Automated.AfterMedicalAlertAdded.value && <PersonOption header="Medical Alert" set={EVO.any(values.medicalAlerts)} excludeName="medicalAlertsExclude">
                    {props.medicalAlerts && <Field name="medicalAlerts" component={PTInputSelect} options={EVO.getSelectItemFromSingularArray(props.medicalAlerts)} isMulti={true} />}
                </PersonOption>}
            </div>;
        }

        return '';
    };

    const RenderGroupTitle = ({ gKey }) => {
        const g = groups[gKey];
        if (EVO.any(g.whenAutomatedHide, a => a === values.whenAutomatedId)) {
            return null;
        }

        return <div onClick={() => setSelectedGroup(g)} className={classNames('ncd-filter-option', { active: selectedGroup.id === g.id })}>
            <span>{g.name}</span>
        </div>
    };

    return (<div>
        <Question>Who should receive it?</Question>
        {useMemo(() => <div>
            <div className="ncd-filter-options-wrapper">
                <div className="ncd-filter-options">
                    {Object.keys(groups).map(g => <RenderGroupTitle key={g} gKey={g} />)}
                    <PTErrors fields={['appointmentCategories', 'appointmentTypes', 'practitioners', 'oneOffSomeError', 'whenAutomatedMagnitudeValue', 'whenMagnitudeId', 'appointmentCount', 'medicalAlerts', 'appointmentCountEqualityId']} />
                </div>
                <div className="ncd-filter-options-items">
                    <RenderGroup g={selectedGroup} />
                </div>
            </div>
        </div>, [appointmentTypes, selectedGroup, values.requiresUpcomingAppointmentsCheck])}
    </div>);
}

const PersonOption = ({ excludeName, children, set, header, required, subHeader }) => {
    const { values, setFieldValue } = useFormikContext();

    const [expanded, setExpanded] = useState(['Appointment Date Range']);
    const [expand, setExpand] = useState(expanded.includes(header));
    const [excluded, setExcluded] = useState(excludeName && values[excludeName]);


    const handleExclude = () => {
        setFieldValue(excludeName, !excluded);
        setExcluded(!excluded);
    };

    const handleExpand = () => {
        setExpand(!expand);
        if (!expand) {
            setExpanded([...expanded, header]);
        }
        else {
            setExpanded(expanded.filter((e) => (e !== header)));
        }
    };

    return (<div className={classNames("person-option", { 'active': expand || set })}>
        <div className="po-header" onClick={handleExpand}>{header}{required && <span>*</span>}</div>
        <div className="po-content">
            {subHeader && <div className="po-subheader">{subHeader}</div>}
            {excludeName && <div>This filter is set to <span onClick={handleExclude} className={classNames('po-include-exclude', {
                include: !excluded,
                exclude: excluded
            })}>{excluded ? "exclude" : "include"}</span><PTInfo info={`Select the ${EVO.ploralise(header.toLowerCase())} you'd like to ${excluded ? 'exclude' : 'include'}. Leave blank to send to all. Click to change to ${excluded ? 'include' : 'exclude'}`} /></div>}
            <div className={classNames('po-options', {
                include: excludeName && !excluded,
                exclude: excludeName && excluded
            })}>{children}</div>
        </div>
    </div>);
};

const NumberOfAppointments = ({ hideOptions }) => {
    const { values } = useFormikContext();
    let title = 'Total appointment count';
    let set = EVO.hasValue(values.appointmentCount) && EVO.isNumber(values.appointmentCount);
    let subHeader = 'Only sends if the appointment count matches these conditions. Your other filters will not apply to this count unless you tick the box below';
    let required = false;

    if (values.scheduleTypeId === scheduleTypes.OneOff.value) {
        subHeader = 'Only sends if the appointment count matches these conditions. Your other filters excluding the date range filter will not apply to this count unless you tick the box below';
    }
    else if (values.whenAutomatedId === when_Automated.OnCount.value) {
        title = 'Number of Appointments';
        subHeader = `Define the number of appointments that should trigger this message. For example, if you want to send a patient a message on their 5th appointment you would enter '5' here. Other filters you apply will also apply to this count. For example, if you set an appointment type, the patient will have had to have had 5 of that appointment type for this to trigger`;
        set = true;
        required = true;
    }

    const [options, setOptions] = useState([]);
    useEffect(() => {
        let allOptions = [];
        Object.keys(appointmentCountEquality).forEach(o => {
            var option = appointmentCountEquality[o];
            if (!hideOptions || option.value === appointmentCountEquality.Equal.value) {
                allOptions.push(option);
            }
        });
        
        setOptions(allOptions);
    }, [values.whenAutomatedId]);
    

    return <PersonOption header={title} set={set} subHeader={subHeader} required={required}>
        <div className="ncd-appointmentcount-wrapper">
            <Field className="ncd-appointmentcount-equality" name="appointmentCountEqualityId" component={PTInputSelect} options={options} disabled={hideOptions} />
            <Field className="ncd-appointmentcount" name="appointmentCount" component={PTInputText} type="number" min={0} />
        </div>
        {(values.whenAutomatedId !== when_Automated.OnCount.value && values.whenAutomatedId !== when_Automated.AfterInvoiceCreated.value && values.whenAutomatedId !== when_Automated.AfterInvoiceClosed.value) &&
            <div className="ncd-apply-filters-wrapper">
                <Field name="appointmentCountApplyFilters" component={PTInputCheckbox} placeholder="Apply my other filters to this count" />
            </div>}
    </PersonOption>
};

const groups = {
    Essentials: { name: 'The essentials', id: 1 },
    Demographics: {
        name: 'Demographics',
        id: 2
    },
    Appointment: {
        name: 'Appointment',
        id: 3,
        whenAutomatedHide: [when_Automated.AfterInvoiceCreated.value, when_Automated.AfterInvoiceClosed.value]
    },
    Other: {
        name: 'Other',
        id: 4
    }
};


const mapStateToProps = ({ ensure }) => ({
    appointmentTypes: ensure.appointmentTypes,
    practitioners: ensure.practitioners,
    appointmentCategories: ensure.appointmentCategories,
    businesses: ensure.businesses,
    billableItems: ensure.billableItems,
    products: ensure.ptProducts,
    sexes: ensure.sexes,
    medicalAlerts: ensure.medicalAlerts
});

export const NCDFilter = connect(mapStateToProps, actions)(NCDF);


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NCDFilter.js